<script setup lang="ts">
import { inject, reactive, ref } from 'vue'
// components
import itemPanel from './itemPanel.vue'
// types
import { PopupInfo, ugcType } from '@/components/GlobalUgcPopup/types'

const isShowUgcPopup = inject('isShowUgcPopup', ref(false))
const globalUgcPopupData = inject<PopupInfo | any>('globalUgcPopupData', reactive({}))
</script>

<template>
  <div class="pop-bottom">
    <div class="bottom-con margin-b12" v-for="(popupData, i) in globalUgcPopupData.popupData" :key="i">
      <div class="pop-con" v-if="popupData[0]?.type !== ugcType.CANCELBUTTON">
        <itemPanel
          v-for="(item, j) in popupData"
          :key="j"
          :item="item"
          :show-line="popupData.length > 1 && i < popupData.length - 1"
          :user="globalUgcPopupData.actionUserInfo"
        />
      </div>
      <div class="pop-cancel flex_align_center" v-else @click.stop="isShowUgcPopup = false">
        <span class="fs-14">取消</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pop-bottom {
  background-color: #f5f5f5;
  border-radius: 12px 12px 0 0;
  overflow: hidden;

  .bottom-con {
    background-color: #ffffff;
    border-radius: 12px;
    margin: 14px;

    :deep(.item-panel) {
      padding: 12px 15px;
    }
  }

  .pop-cancel {
    width: 353px;
    height: 44px;
    border-radius: 22px;
    background-color: #ffffff;
    justify-content: center;

    span {
      color: #333333;
      line-height: 1;
      font-weight: 500;
    }
  }
}
</style>
